const skills = {
  1: [
    {
      title: "HTML",
      level: 6,
    },
    {
      title: "CSS",
      level: 5,
    },
    {
      title: "SASS",
      level: 2,
    },
    {
      title: "JavaScript",
      level: 5,
    },
    {
      title: "TypeScript",
      level: 4,
    },
    {
      title: "Tailwind CSS",
      level: 1,
    },
    {
      title: "React JS",
      level: 3,
    },
    {
      title: "Figma",
      level: 4,
    },
  ],
  2: [
    {
      title: "PostgreSQL",
      level: 5,
    },
    {
      title: "Node.js",
      level: 4,
    },
    {
      title: "MongoDB",
      level: 2,
    },
    {
      title: "Git",
      level: 4,
    },
    {
      title: "PHP",
      level: 1,
    },
    {
      title: "SQL",
      level: 3,
    },
    {
      title: "Express.js",
      level: 3,
    },
  ],
};

export default skills;
